var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.showHead
    ? _vm.__get_style([
        {
          padding: _vm.padding + "rpx",
        },
        _vm.headStyle,
      ])
    : null

  var s1 = _vm.__get_style([
    {
      padding: _vm.padding + "rpx",
    },
    _vm.bodyStyle,
  ])

  var s2 = _vm.showFoot
    ? _vm.__get_style([
        {
          padding: _vm.$slots.foot ? _vm.padding + "rpx" : 0,
        },
        _vm.footStyle,
      ])
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        s1: s1,
        s2: s2,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }